import React from "react";

const BlogSkeleton = () => {
  return (
    <div className="animate-pulse">
      <div className="bg-gray-300 h-56 w-full rounded-2xl mb-4"></div>

      <div className="flex items-center justify-between mb-3 px-5">
        <div className="bg-gray-300 h-4 w-12 rounded"></div>
        <div className="bg-gray-300 h-4 w-20 rounded"></div>
      </div>

      <div className="flex flex-col justify-center items-center">
        <div className="bg-gray-300 h-5 w-3/4 mb-2 rounded"></div>
        <div className="bg-gray-300 h-5 w-3/5 mb-2 rounded"></div>
      </div>
      <div className="flex justify-center items-center mt-5">
        <div className="bg-gray-300 h-4 w-1/3 rounded"></div>
      </div>
    </div>
  );
};

export default BlogSkeleton;